module.exports = __webpack_public_path__ + "static/media/proj10_img3.60d7a42b.jpg";